import React from 'react'
import { 
    CodeBracketIcon,
    DevicePhoneMobileIcon,
    ArchiveBoxIcon,
    PaperAirplaneIcon
        } from '@heroicons/react/24/outline'

function Service() {
  return (
    <section className="bg-neutral-100 pb-14 pt-7 border-y border-neutral-300">
        <div className="max-w-screen-lg py-8 mx-auto">
            <div role="contentinfo" className="flex flex-col px-6 md:px-10">
                <p tabindex="0" className="focus:outline-none uppercase text-base text-gray-900 leading-4 font-bold">What i will do for you?</p>
            </div>
            <div tabindex="0" aria-label="group of cards" className="focus:outline-none mt-5 flex flex-wrap justify-center gap-10 px-4">

                <div className="w-full md:w-72 px-5 py-3 bg-white border border-neutral-300 hover:bg-gray-100">
                    <div className="flex items-center ">
                        <CodeBracketIcon className=" w-5 h-5 text-gray-900" />
                        <p className="text-gray-900 ml-2" tabindex="0">Software development</p>
                    </div>
                </div>
                <div className="w-full md:w-72 px-5 py-3 bg-white border border-neutral-300 hover:bg-gray-100">
                    <div className="flex items-center ">
                            <DevicePhoneMobileIcon className=" w-5 h-5 text-gray-900"/>
                            <p className="text-gray-900 ml-2" tabindex="0">UI/UX Design</p>
                    </div>
                </div>
                <div className="w-full md:w-72 px-5 py-3 bg-white border border-neutral-300 hover:bg-gray-100">
                    <div className="flex items-center ">
                        <ArchiveBoxIcon className=" w-5 h-5 text-gray-900"/>
                        <p className="text-gray-900 ml-2">Brand Design</p>
                    </div>
                </div>

            </div>
        </div>

        <div className="max-w-screen-lg mx-auto bg-primaryGreen">
            <div className="mx-auto max-w-7xl py-3 px-3 sm:px-6 lg:px-8">
                <div className="flex flex-wrap items-center justify-between">
                    <div className="flex w-0 flex-1 items-center">
                        <p className="ml-3 truncate font-medium text-white">
                            <span className="">Let's create your stunning digital products now !</span>
                        </p>
                    </div>
                    <div className="order-3 mt-2 w-full flex-shrink-0 sm:order-2 sm:mt-0 sm:w-auto">
                        <a href="mailto:barakadan421@gmail.com" className="group flex items-center justify-center border border-transparent bg-primaryYellow px-4 py-2 text-sm font-medium text-gray-900 shadow-sm hover:bg-yellow-500">
                            <p className='sm:mr-2'>Send me a message</p>
                            <PaperAirplaneIcon className=" w-5 h-5 text-gray-900 origin-bottom -rotate-12 group-hover:animate-pulse"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    </section>
  )
}

export default Service
